// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"846c4408abbd3e60d652","339":"2cf11362b391f7db6308"}[chunkId] + ".js";
};